// Helpers
import { buildAudienceFilters } from './audienceFilters';
import { getEngagementRateValue } from './campaign';
import { getLocationsForApi } from './campaignEditModal';
// Types
import {
  SearchSocialShareCriteriaInput,
  UserRole,
} from 'api/graphql-global-types';
import { SocialShareCampaignFormValues } from 'pages/Campaigns/components/SocialShareCampaignEditModal/SocialShareCampaignEditModal';

export const getSocialShareCampaignCommonFields = (
  values: SocialShareCampaignFormValues,
  isTikTok?: boolean
): SearchSocialShareCriteriaInput => {
  const {
    userRole,
    budget,
    flatFeePerStore,
    genders,
    maxAge,
    minAge,
    followingFrom,
    followingTo,
    sports,
    hometownLocations,
    excludedLocations,
    engagementRate,
    searchHashtags,
    locations,
    audienceGender,
    audienceAgeRanges,
    audienceEthnicities,
    audienceLocations,
    audienceInterests,
  } = values;

  // a lot ifs because of Expression produces a union type that is too complex to represent.  TS2590, this is a workaround
  const criteria: SearchSocialShareCriteriaInput = {};

  if (userRole) {
    criteria.roles = userRole.length
      ? userRole
      : [UserRole.Athlete, UserRole.ContentCreator];
  }
  if (budget) {
    criteria.budget = Number(budget);
  }
  if (flatFeePerStore) {
    criteria.flatFeePerStore = Number(flatFeePerStore);
  }
  if (genders) {
    criteria.genders = genders;
  }
  if (maxAge) {
    criteria.maxAge = Number(maxAge);
  }
  if (minAge) {
    criteria.minAge = Number(minAge);
  }
  if (followingFrom && followingTo) {
    criteria.socialFollowersRange = {
      from: Number(followingFrom),
      to: Number(followingTo),
    };
  } else if (followingFrom) {
    criteria.socialFollowersRange = {
      from: Number(followingFrom),
    };
  } else if (followingTo) {
    criteria.socialFollowersRange = {
      to: Number(followingTo),
    };
  }
  if (sports) {
    criteria.sports = sports;
  }
  if (locations) {
    criteria.locations = locations;
  }
  if (hometownLocations) {
    criteria.hometownLocations = hometownLocations;
  }
  if (excludedLocations) {
    criteria.excludedLocations = getLocationsForApi(excludedLocations);
  }
  const engagementRateValue = getEngagementRateValue(engagementRate);
  if (engagementRateValue !== null) {
    criteria.engagementRateRange = {
      from: engagementRateValue,
      to: 1,
    };
  }
  if (searchHashtags) {
    criteria.hashtagInputs = searchHashtags.map((hashtag) => ({
      name: hashtag.value,
    }));
  }

  const audienceFilters = buildAudienceFilters({
    audienceGender,
    audienceAgeRanges,
    audienceEthnicities,
    audienceLocations,
    audienceInterests,
    isTikTok,
  });

  if (audienceFilters) {
    criteria.audienceFilters = audienceFilters;
  }

  return criteria;
};
